module.exports = __webpack_public_path__ + "static/img/i1.fdbad501.png";